import { render, staticRenderFns } from "./entry.vue?vue&type=template&id=48c967f8&scoped=true"
import script from "../../assets/ts/entry/entry.ts?vue&type=script&lang=ts&external"
export * from "../../assets/ts/entry/entry.ts?vue&type=script&lang=ts&external"
import style0 from "./entry.vue?vue&type=style&index=0&id=48c967f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c967f8",
  null
  
)

export default component.exports